module.exports = __webpack_public_path__ + "img/Lana_Headshot-photoaidcom-cropped.bcbb6621.JPG";